// Module
var code = "<a class=\"btn subFormControl\"> <i class=\"fa-solid fa-arrow-up-from-bracket\"></i> <span>AI Workflow</span> </a>";
// Exports
export default code;